<template>
  <div>

    <!-- 添加按钮 -->
    <el-button @click="add" type="primary" class="addBtn">添加版本</el-button>

    <!-- 列表 -->
    <el-table v-loading="loading" element-loading-text="拼命加载中" stripe :data="tableData">
      <el-table-column label="版本号" prop="code" min-width="110">
      </el-table-column>
      <el-table-column label="上传时间" prop="createdAt" min-width="180">
      </el-table-column>
      <el-table-column label="指定设备" prop="device" min-width="180">
      </el-table-column>
      <el-table-column label="类型" prop="platform" min-width="110">
      </el-table-column>
      <el-table-column label="备注" prop="remark" min-width="180">
      </el-table-column>
      <el-table-column label="操作" fixed='right' width='200'>
        <template scope="scope">
          <el-button size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button size="small" @click="updateVersion(scope.row)">更新版本</el-button>
        </template>
      </el-table-column>
    </el-table>
     <Page :way="ways" @pageNum='pageNum' @pageOne='pageOne'></Page>  

    <!-- 弹框 编辑 -->
    <el-dialog title="版本操作" :visible.sync="dialogFormVisible" >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="版本号" :label-width="formLabelWidth" prop="code">
          <el-input v-model="form.code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label='文件地址' :label-width="formLabelWidth" prop="fileUrl">
          <el-input v-model="form.fileUrl" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="指定设备" :label-width="formLabelWidth" prop="device">
          <el-select v-model="hid" filterable multiple collapse-tags  placeholder="请选择">
            <el-option v-for="(item, index) in list" :label="item.hid" :key="index" :value="item.hid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本" :label-width="formLabelWidth" prop="platform">
          <el-select v-model="form.platform"  placeholder="请选择">
            <el-option label="xtg_v01" value="xtg_v01"></el-option>
            <el-option label="xtg_v02" value="xtg_v02"></el-option>
            <el-option label="lua_v01" value="lua_v01"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label-width="formLabelWidth" label="更新时间" prop='upgradedAt'>
          <div class="block">
            <el-date-picker
              v-model="form.upgradedAt"
              type="date"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="form.remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editOpt('form')" v-if="editLoad">编 辑</el-button>
        <el-button type="primary" @click="addOpt('form')" v-if="addLoad">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import util from "../../util/util";
import Page from "../../components/Page.vue";
import cookie from "./../../util/cookie";

export default {
  components: {
    Page
  },
  data() {
    return {
      tableData: [],
      loading: true,
      hid: [],
      form: {
        code: "",
        remark: "",
        fileUrl: "",
        platform: "xtg_v02",
      },
      flag: false,
      files: "buffer",
      editLoad: false,
      addLoad: false,
      dialogFormVisible: false,
      eidtData: {},
      formLabelWidth: "120px",
      list: [],
      ways: "/versions",
      limit: util.limit,
      skip: util.skip,
      rules: {
        code: [{ required: true, message: "请填写版本号", trigger: "blue" }],
        fileUrl: [
          { required: true, message: "请填写文件地址", trigger: "blur" }
        ]
        // upgradedAt: [
        //   { type: 'date', required: true, message: '请填写选择更新时间', trigger: 'blur' }
        // ],
      }
    };
  },
  methods: {
    updateVersion(version) {
        this.$confirm("此操作将更新版本, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(() => {
          axios.post("/versions/" + version.objectId + "/update").then(response => {
              this.$message({
                type: "success",
                message: "下发更新成功！!"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作！"
          });
        });
    },
    editOpt(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false;
          let obj = {
            code: this.form.code,
            remark: this.form.remark,
            fileUrl: this.form.fileUrl,
            platform: this.form.platform
          };
          obj.device = this.hid;
          axios
            .put("/versions/" + this.editData.objectId, obj)
            .then(response => {
              this.getData();
            });
        } else {
          return false;
        }
      });
    },
    addOpt(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false;
          let obj = {
            code: this.form.code,
            remark: this.form.remark,
            fileUrl: this.form.fileUrl,
            platform: this.form.platform
          };
          if (this.hid.length > 0) {
            obj.device = this.hid;
          }
          axios.post("/versions", obj).then(response => {
            this.getData();
          });
        } else {
          return false;
        }
      });
    },
    pageNum(msg) {
      this.limit = msg;
      this.getData();
    },
    pageOne(msg) {
      this.skip = msg - 1;
      this.getData();
    },
    getData() {
      this.loading = true;
      axios
        .get("/versions", {
          params: {
            limit: this.limit,
            skip: this.skip * this.limit,
            order: "-createdAt"
          }
        })
        .then(response => {
          this.tableData = response.data;
          this.tableData.filter(item => {
            item.createdAt = util.dateForm(item.createdAt);
            item.device = (item.device
              ? item.device.length == 0 ? "全部设备" : item.device
              : "全部设备");
          });
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    getCabinets(obj) {
      this.hid = [];
      this.flag = false;
      axios.get("/cabinets", {params:{limit:10000,skip:0}}).then(response => {
        this.list = response.data;
        for (let i = 0; i < this.list.length; i++) {
          if (obj && obj.device && obj.device.indexOf(this.list[i].hid) != -1) {
            this.hid.push(this.list[i].hid);
          }
        }
      });
    },
    add() {
      this.dialogFormVisible = true;
      this.editLoad = false;
      this.addLoad = true;
      this.form = {
        code: "",
        remark: "",
        fileUrl: "",
        platform: "xtg_v02",
      };
      this.getCabinets();
    },
    edit(row) {
      this.getCabinets(row);
      this.dialogFormVisible = true;
      this.editData = row;
      this.editLoad = true;
      this.addLoad = false;
      this.form.code = row.code;
      this.form.remark = row.remark;
      this.form.fileUrl = row.fileUrl;
      this.form.platform = row.platform;
      row.device == "全部设备" ? (this.flag = false) : (this.flag = true);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.addBtn {
  @include floatBtn;
}
</style>



// WEBPACK FOOTER //
// src/views/version/Version.vue?6cdeb5eb